// ChangeMyPinDialog — zmena vlastného PIN-u na schvaľovanie (Mirko 16. 9. 2026, bod 5: „musím ho vedieť jednoducho zmeniť“)
// Backend: POST /api/auth/zmen-pin (heslo do Matrixu + nový PIN). Po zmene starý PIN hneď prestane platiť.
import React, { useState } from 'react'
import { COLORS, RADIUS, TYPO, SPACE, SHADOW } from '../theme.js'
import { useToast } from '../components/Toast.jsx'
import { fetchAuth } from './fetchAuth.js'

export default function ChangeMyPinDialog({ open, onClose }) {
  const toast = useToast()
  const [heslo, setHeslo] = useState('')
  const [pin, setPin] = useState('')
  const [pin2, setPin2] = useState('')
  const [busy, setBusy] = useState(false)
  if (!open) return null
  const close = () => { setHeslo(''); setPin(''); setPin2(''); onClose() }
  const save = async () => {
    if (!heslo) { toast.error('Zadaj svoje heslo do Matrixu'); return }
    if (!/^\d{4}$/.test(pin)) { toast.error('PIN má presne 4 číslice'); return }
    if (pin !== pin2) { toast.error('PIN a kontrola sa nezhodujú'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/auth/zmen-pin', { method: 'POST', body: JSON.stringify({ heslo, pin }) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) { toast.error(d.error || 'Zmena PIN-u zlyhala'); setBusy(false); return }
      toast.success('PIN zmenený — starý už neplatí')
      setBusy(false); close()
    } catch (e) { toast.error('Chyba siete: ' + e.message); setBusy(false) }
  }
  const inputStyle = { width: '100%', padding: '10px 12px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, fontSize: TYPO.sizes.base, fontFamily: 'inherit', marginTop: 4, boxSizing: 'border-box' }
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: SPACE.md }} onClick={close}>
      <div role="dialog" aria-modal="true" onClick={e => e.stopPropagation()} style={{ width: 420, maxWidth: '100%', background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.xl, padding: '28px 26px', boxShadow: SHADOW.lg, fontFamily: TYPO.family }}>
        <h3 style={{ margin: 0, marginBottom: SPACE.sm, fontSize: TYPO.sizes.lg }}>Zmeniť môj PIN</h3>
        <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, marginBottom: SPACE.md, lineHeight: 1.45 }}>
          PIN schvaľuje citlivé úkony (výdaj bez dokladu, veľký výdaj, zmazanie natvrdo, uloženie duplicity, odomknutie výmer). Zadávaš ho len ty — nikomu ho nehovor. Po zmene starý PIN hneď prestane platiť.
        </div>
        <div style={{ marginBottom: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Tvoje heslo do Matrixu (overenie, že si to ty)</div>
          <input type="password" value={heslo} onChange={e => setHeslo(e.target.value)} style={inputStyle} autoFocus autoComplete="current-password" />
        </div>
        <div style={{ marginBottom: SPACE.md }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Nový PIN (4 číslice)</div>
          <input type="password" inputMode="numeric" maxLength={4} value={pin} onChange={e => setPin(e.target.value.replace(/\D/g, ''))} style={inputStyle} autoComplete="new-password" />
        </div>
        <div style={{ marginBottom: SPACE.lg }}>
          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Nový PIN znova</div>
          <input type="password" inputMode="numeric" maxLength={4} value={pin2} onChange={e => setPin2(e.target.value.replace(/\D/g, ''))} onKeyDown={e => { if (e.key === 'Enter') save() }} style={inputStyle} autoComplete="new-password" />
        </div>
        <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
          <button onClick={close} disabled={busy} style={{ padding: '9px 18px', border: `1px solid ${COLORS.line}`, background: COLORS.bg, color: COLORS.text, borderRadius: RADIUS.md, fontSize: TYPO.sizes.base, cursor: 'pointer', fontFamily: 'inherit' }}>Zrušiť</button>
          <button onClick={save} disabled={busy} style={{ padding: '9px 18px', border: 'none', background: COLORS.add, color: '#fff', borderRadius: RADIUS.md, fontSize: TYPO.sizes.base, cursor: 'pointer', fontFamily: 'inherit', fontWeight: 700 }}>{busy ? 'Ukladám…' : 'Uložiť PIN'}</button>
        </div>
      </div>
    </div>
  )
}
